import * as types from "./types"

export const login = (payload) => ({
  type: types.LOGIN,
  payload
})
export const logout = () => ({ type: types.LOGOUT })
export const openLoading = () => ({ type: types.OPEN_LOADING })
export const closeLoading = () => ({ type: types.CLOSE_LOADING })
export const openTimeoutDialog = () => ({ type: types.OPEN_TIMEOUT_DIALOG })
export const closeTimeoutDialog = () => ({ type: types.CLOSE_TIMEOUT_DIALOG })
export const saveMenustatus = (payload) => ({
  type: types.SAVE_MENU_STATUS,
  payload
})
export const updateAuthList = (payload) => ({
  type: types.UPDATE_AUTH_LIST,
  payload
})
